<header class="header-container">
  <div class="header gap-4">
    @if (loadingUserInfo()) {
      <p-skeleton width="200px" height="2rem" class="flex-1" />
    } @else {
      <h1 class="inline title-m flex-1">
        {{ "header.greetings" | translate: user() }}
      </h1>
    }
    <div class="company-section">
      @if (selectedCompany()?.logoUrl) {
        <div class="logo-hover flex items-center justify-end">
          <img [src]="selectedCompany()?.logoUrl" alt="Logo" class="logo" />
          <p-button
            class="hidden-btn"
            [label]="'buttons.edit' | translate"
            [rounded]="true"
            severity="secondary"
            icon="pi pi-pencil"
            size="small"
            (onClick)="editLogo()"
          />
        </div>
      } @else {
        <div class="flex items-center justify-end">
          <p-button
            [label]="'header.addLogo' | translate"
            [rounded]="true"
            severity="secondary"
            icon="pi pi-plus"
            size="small"
            (click)="addLogo()"
          />
        </div>
      }
      <p-select
        [options]="companies()"
        [ngModel]="selectedCompany()?.CLIEN_NM"
        (onChange)="changeCompany($event)"
        (onFilter)="filterCompanies($event)"
        [loading]="isLoadingSelect()"
        optionLabel="TERCE_DS"
        optionValue="CLIEN_NM"
        class="w-full"
        filter
        [filterPlaceholder]="'header.companyFilterPlaceholder' | translate"
        [virtualScroll]="true"
        [virtualScrollItemSize]="40"
        [virtualScrollOptions]="virtualScrollOptions"
      >
        <ng-template let-company #item>
          <div class="flex items-center justify-between gap-2 w-full">
            <div>{{ company.TERCE_DS }}</div>
            @if (selectedCompany()?.CLIEN_NM === company.CLIEN_NM) {
              <i class="pi pi-check-circle success-icon"></i>
            }
          </div>
        </ng-template>
      </p-select>
    </div>
    <div class="flex items-center justify-end language-section flex-1">
      <p-select
        [options]="languages"
        [(ngModel)]="selectedLanguage"
        (onChange)="changeLanguage($event)"
      >
        <ng-template #selectedItem let-selectedOption>
          @if (selectedOption) {
            <div class="flex items-center gap-2">
              <img [src]="selectedOption.flag" alt="Flag" class="flag-icon" />
              <div>{{ selectedOption.code?.toUpperCase() }}</div>
            </div>
          }
        </ng-template>
        <ng-template let-country #item>
          <div class="flex items-center gap-2">
            <img [src]="country.flag" alt="Flag" class="flag-icon" />
            <div>{{ country.name }}</div>
            @if (selectedLanguage.code === country.code) {
              <i class="pi pi-check-circle success-icon"></i>
            }
          </div>
        </ng-template>
      </p-select>
    </div>
  </div>
</header>
<app-add-edit-logo-dialog
  [(visible)]="addEditLogoDialogVisible"
  [dialogMode]="addEditLogoDialogMode()"
  [existingFile]="existingFile()"
></app-add-edit-logo-dialog>
